import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Table } from 'foundations-components/transitional/components/Table';
import VariantsModalRow from 'personalization-lib/components/variantsModal/VariantsModalRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantsModalBody = ({
  variants,
  loading,
  error
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "variants-loading",
      grow: true,
      minHeight: "300px"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.variantsModal.error.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.variantsModal.error.subtitle"
      })
    });
  }
  return /*#__PURE__*/_jsxs(Table, {
    maxInlineSize: "470px",
    "data-test-id": "variants-table",
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "personalizationLib.variantsModal.table.header"
          })
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: variants.map(variant => /*#__PURE__*/_jsx(VariantsModalRow, Object.assign({}, variant, {
        loading: loading,
        error: error
      }), variant.assetCoordinates.id))
    })]
  });
};
export default VariantsModalBody;